"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerResponse = exports.CacheStats = void 0;
const runtypes_1 = require("runtypes");
const submission_1 = require("./submission");
const testresults_1 = require("./testresults");
const testtesting_1 = require("./testtesting");
exports.CacheStats = (0, runtypes_1.Record)({
    hits: runtypes_1.Number,
    misses: runtypes_1.Number,
});
exports.ServerResponse = (0, runtypes_1.Record)({
    type: submission_1.SubmissionType,
    canCache: runtypes_1.Boolean,
    cacheStats: exports.CacheStats,
    duration: runtypes_1.Number,
    version: runtypes_1.String,
}).And((0, runtypes_1.Partial)({
    solveResults: testresults_1.TestResults,
    testTestingResults: testtesting_1.TestTestResults,
}));
//# sourceMappingURL=server.js.map